













































































































































































































































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import moment from 'moment'
import CockpitRequest from '../model/request/CockpitRequest'
import CockpitPerformancePorDataResponse from '@/model/response/CockpitPerformancePorDataResponse'
import ItDisplay from '@/components/itrack/ItDisplay.vue'

@Component({
  components: {ItDisplay},
})
export default class PerformanceData extends Vue {
  @Prop({type: Object, required: true}) value!: CockpitPerformancePorDataResponse

  get response() {
    return this.value
  }

  get totalEntregue() {
    let total = 0

    Object.keys(this.response.entregue).forEach((key) => {
      total += this.response.entregue[key] || 0
    })

    return total
  }

  get totalPendente() {
    let total = 0

    Object.keys(this.response.pendente).forEach((key) => {
      total += this.response.pendente[key] || 0
    })

    return total
  }

  formattedDate(daysAgo = 0, prefix = '') {
    const date = moment()
      .add(-daysAgo, 'days')
      .startOf('date')
      .format('DD/MM')
    return `${prefix}${date}`
  }
}
